import Vue from 'vue'
import {
    Dialog
} from 'vant';
Vue.use(Dialog);

// 统一维护一些提示组件，避免全局修改
export default {
    // 确认组件
    // 因为vant确认组件需要处理catch，这里默认无须处理
    confirm(params, isReject = false) {
        return new Promise((resolve, reject) => {
            Dialog
                .confirm(params)
                .then(() => {
                    resolve();
                }).catch(() => {
                    if (isReject) {
                        reject()
                    }
                });
        })
    },
    // 弹窗组件
    alert(params) {
        return new Promise((resolve, reject) => {
            Dialog
                .alert(params)
                .then(() => {
                    resolve();
                });
        })
    }
}